// Console view of Feed v1. The contract, mapping, ordering, ack rule, and refusal allowlist all
// live in @secops/shared so the console author view and the guard read view cannot disagree about
// what a post is. This module adds only what is console-shaped: display formatting in the
// account's zone and the audience options for the author form.
//
// SERVER: public RPCs from migration 20260807230000_feed_v1.sql (PR #204).

export {
  ACK_FEED_POST_RPC,
  EMPTY_FEED_POST_DRAFT,
  FEED_AUDIENCE_KINDS,
  FEED_LOAD_FAILED,
  FEED_MANAGE_PERMISSION,
  FEED_UNAVAILABLE,
  GET_FEED_POST_RPC,
  KNOWN_FEED_FAILURES,
  LIST_FEED_POSTS_RPC,
  LIST_FEED_POST_ACKS_RPC,
  PUBLISH_FEED_POST_RPC,
  SAFE_FEED_FAILURE,
  SET_FEED_POST_PINNED_RPC,
  SET_FEED_POST_REQUIRE_ACK_RPC,
  acknowledgeFeedPost,
  fetchFeedAckRoster,
  fetchFeedPost,
  fetchFeedPosts,
  mapFeedAckRoster,
  mapFeedPost,
  mapFeedPosts,
  needsAcknowledgement,
  outstandingAckCount,
  publishFeedPost,
  setFeedPostPinned,
  setFeedPostRequireAck,
  sortFeedPosts,
  validateFeedPostDraft,
} from "../../../../packages/shared/src/feed.ts";

export type {
  FeedAckRosterEntry,
  FeedAudienceKind,
  FeedLoad,
  FeedPost,
  FeedPostDraft,
  FeedWriteOutcome,
} from "../../../../packages/shared/src/feed.ts";

import type { ClientRow, ManagedSite } from "./clients-sites";
import type { FeedAudienceKind } from "../../../../packages/shared/src/feed.ts";

export interface FeedAudienceOption {
  readonly kind: FeedAudienceKind;
  readonly id: string | null;
  readonly label: string;
}

export const ALL_COMPANY_AUDIENCE: FeedAudienceOption = {
  kind: "account",
  id: null,
  label: "All company",
};

/**
 * Audience choices for the author form. v1 server targeting is empty arrays = all active members;
 * site/group rules are not on the RPC yet, so only All company is offered.
 */
export function feedAudienceOptions(
  _sites: readonly ManagedSite[] = [],
  _clients: readonly ClientRow[] = [],
): FeedAudienceOption[] {
  return [ALL_COMPANY_AUDIENCE];
}

/** Encode an audience choice for a <select> value, and read it back. */
export function encodeAudienceValue(option: FeedAudienceOption): string {
  return option.id === null ? option.kind : `${option.kind}:${option.id}`;
}

export function decodeAudienceValue(
  value: string,
  options: readonly FeedAudienceOption[],
): FeedAudienceOption {
  return options.find((option) => encodeAudienceValue(option) === value) ?? ALL_COMPANY_AUDIENCE;
}
